import {Store} from 'client/common/types';

import {EditMode, SurveyState} from 'client/common/store/reducers/survey/types';

import {getUserIsSuperuser} from 'client/common/store/selectors/user';

export function getSlug(state: Store): string | undefined {
    return state.survey.slug;
}

export function getSurvey(state: Store) {
    return state.survey;
}

export function getEditMode(state: Store): EditMode {
    const {state: surveyState} = getSurvey(state);
    const userIsSuperuser = getUserIsSuperuser(state);

    if (
        !surveyState ||
        surveyState === SurveyState.Draft ||
        (surveyState === SurveyState.Moderation && userIsSuperuser)
    ) {
        return EditMode.Everything;
    }

    if (surveyState === SurveyState.Moderation) {
        return EditMode.Launched;
    }

    return EditMode.Completed;
}

export function getSurveyClientId(state: Store): string | undefined {
    return state.survey.clientId;
}
